import React, { useEffect } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import dnaWelcomeAnimation from 'on_web/assets/images/dna-welcome-animation.svg';

import MainTitle from 'on_web/components/shared/Common/MainTitle';
import SplashScreen from 'on_web/components/shared/SplashScreen/SplashScreen';

import { useTranslation } from 'react-i18next';
import { introScreensTimeout } from 'on_web/helpers/constants';

function DnaWelcome(props) {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (props.onWelcome) {
        props.onWelcome();
      }
    }, introScreensTimeout);

    return () => {
      clearTimeout(timer);
    };
  });

  const { t } = useTranslation();
  return (
    <div>
      <Header />
      <SplashScreen>
        <MainTitle
          text={t('onboarding.dnaSection.dnaWelcome.title')}
        ></MainTitle>
        <img src={dnaWelcomeAnimation} alt="welcome animation" />
      </SplashScreen>
    </div>
  );
}

export default DnaWelcome;
